import { useState, useEffect } from 'react';
import { Table, Input, Button, message, Modal, Space, Tag } from 'antd';
import { SearchOutlined, ReloadOutlined } from '@ant-design/icons';
import axios from 'axios';

const API = import.meta.env.VITE_API_BASE || '/api';
const h = () => ({ Authorization: 'Bearer ' + localStorage.getItem('ar_token') });

export default function CustomerManage() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [keyword, setKeyword] = useState('');

  const fetchData = async () => {
    setLoading(true);
    try {
      const r = await axios.get(API + '/admin/customers', { headers: h(), params: { keyword } });
      if (r.data.success) setData(r.data.data || []);
    } catch { message.error('加载失败'); }
    setLoading(false);
  };

  useEffect(() => { fetchData(); }, []);

  const handleResetPwd = (record) => {
    Modal.confirm({
      title: '重置密码',
      content: `确认将 ${record.ccusname}（${record.cCusCode}）的密码重置为 123456？`,
      okText: '确认重置',
      cancelText: '取消',
      onOk: async () => {
        try {
          await axios.post(API + `/admin/customer/${record.cCusCode}/reset-password`,
            { new_password: '123456' }, { headers: h() });
          message.success(`${record.cCusCode} 密码已重置为 123456`);
        } catch (e) { message.error(e.response?.data?.detail || '重置失败'); }
      },
    });
  };

  return (
    <div>
      <Space style={{ marginBottom: 16 }}>
        <Input placeholder="客户代码 / 客户名称" value={keyword}
          onChange={e => setKeyword(e.target.value)}
          onPressEnter={fetchData}
          style={{ width: 260 }} prefix={<SearchOutlined />} allowClear />
        <Button type="primary" onClick={fetchData} icon={<SearchOutlined />}>查询</Button>
        <Button onClick={() => { setKeyword(''); setTimeout(fetchData, 0); }} icon={<ReloadOutlined />}>刷新</Button>
      </Space>

      <Table dataSource={data} loading={loading} rowKey="cCusCode" size="small"
        pagination={{ pageSize: 15, showTotal: t => `共 ${t} 条` }}>
        <Table.Column title="客户代码" dataIndex="cCusCode" width={130} />
        <Table.Column title="客户名称" dataIndex="ccusname" ellipsis />
        <Table.Column title="操作" width={120}
          render={(_, r) => (
            <Button type="link" size="small" danger onClick={() => handleResetPwd(r)}>重置密码</Button>
          )} />
      </Table>
    </div>
  );
}
